import React from 'react';

import {Button, Stack, Typography} from '@mui/material';

import {AlertModal} from 'presentation/components/AlertModal';
import {Drawer} from 'presentation/components/Drawer';
import {useMediaQueries} from 'presentation/pages';
import {translations} from 'presentation/translations-new';

import {AdvanceDiagnosticsLocationModalProps} from './types';

const {
	headerTitle,
	title,
	description,
	unitName,
	unitAddress,
	continue: continueLabel,
	confirmAndContinue,
	back,
} = translations['pt-br'].privateFlow.home.advanceDiagnosticsLocationModal;

function AdvanceDiagnosticsLocationModal({
	open,
	onClose,
	onContinue,
}: AdvanceDiagnosticsLocationModalProps) {
	const {isMobile} = useMediaQueries();

	if (isMobile) {
		return (
			<Drawer.Root open={open} onOpen={() => {}} onClose={onClose}>
				<Drawer.Header title={title} onClose={onClose} fontSize="1.125rem" />
				<Drawer.Content gap={2}>
					<Typography variant="body2">{description}</Typography>
					<Stack>
						<Typography variant="subtitle1" fontWeight={600} color="primary">
							{unitName}
						</Typography>
						<Typography variant="body2">{unitAddress}</Typography>
					</Stack>
				</Drawer.Content>
				<Drawer.Footer
					direction="column-reverse"
					firstButtonTitle={back}
					firstButtonOnClick={onClose}
					secondButtonTitle={confirmAndContinue}
					secondButtonOnClick={onContinue}
				/>
			</Drawer.Root>
		);
	}

	return (
		<AlertModal
			open={open}
			onClose={onClose}
			variant="warning"
			headerTitle={headerTitle}
			title={title}
			description={description}
			subDescription={
				<Stack alignItems="center" textAlign="center">
					<Typography variant="subtitle1" fontWeight={600} color="primary">
						{unitName}
					</Typography>
					<Typography variant="body2">{unitAddress}</Typography>
				</Stack>
			}
			footerProps={{sx: {display: 'flex', flexDirection: 'column', gap: 1}}}
			footerContent={
				<Stack width="100%" gap={1}>
					<Button fullWidth size="large" variant="contained" onClick={onContinue}>
						{continueLabel}
					</Button>
					<Button fullWidth size="large" variant="outlined" onClick={onClose}>
						{back}
					</Button>
				</Stack>
			}
		/>
	);
}

export {AdvanceDiagnosticsLocationModal};
